import Layout from "../Layouts/Index";
import BoxHeader from "../components/BoxHeader";
import BlogCard from "../components/BlogCard";
import React from "react";
import {Client} from "../Services/Prismic";
import Prismic from "@prismicio/client";
import NoData from "../components/NoData";
import LoadingDiv from "../components/Loading";
import {Link} from "react-router-dom";

const Blogs = () => {
    const [blogs, setBlogs] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(true)
    const [nextPage, setNextPage] = React.useState(null)
    const [previousPage, setPreviousPage] = React.useState(null)
    const pageString = (new URLSearchParams(window.location.search)).get("page") || 1

    React.useEffect(() => {
        const fetchData = async () => {
            const response = await Client.query(
                Prismic.Predicates.at('document.type', 'blog'),
                { pageSize : 50, page : pageString, orderings : '[document.last_publication_date desc]' },
            )
            if (response) {
                // console.log(response)
                setBlogs(response.results)
                setNextPage(response.next_page)
                setPreviousPage(response.prev_page)
                setIsLoading(false)
            }
        }
        fetchData()
    }, [pageString])

    const text = ""
    const blog_lists = blogs.map((blog, key) => {
        return (
            <div key={key} className="w-full sm:w-1/2 lg:w-1/3">
                <div className="px-4 py-4">
                    <BlogCard blog={blog} />
                </div>
            </div>
        )
    });

    return (
        <Layout>
            <div className="px-2 sm:px-4 md:px-10 lg:px-16 py-4">
                <BoxHeader title="The Parizzo Blog" text={text} />

                {isLoading ? <LoadingDiv></LoadingDiv> :
                    <div>
                        {blogs.length > 0 ?
                            <div className="py-6 lg:-mx-4">
                                <div className="flex flex-wrap items-start">
                                    {blog_lists}
                                </div>
                            </div>
                            :
                            <NoData text="No Blogs Available."/>
                        }
                    </div>
                }

                <div className="flex justify-center items-center space-x-2 mt-4 mb-8">
                    {
                        previousPage
                            ? <Link
                                className="w-24 text-center py-1.5 px-3 shadow-sm border bg-white hover:bg-gray-600 hover:text-white rounded-md text-gray-600"
                                to={`/blogs?page=${parseInt(pageString) - 1}`}>
                                Previous
                            </Link>
                            : null
                    }
                    {
                        nextPage
                            ? <Link
                                className="w-24 text-center py-1.5 px-3 shadow-sm border bg-white hover:bg-gray-600 hover:text-white rounded-md text-gray-600"
                                to={`/blogs?page=${parseInt(pageString) + 1}`}>
                                Next</Link>
                            : null
                    }

                </div>
            </div>
        </Layout>
    )
}

export default Blogs